module.exports = __webpack_public_path__ + "static/media/natour_small.635730ae.webp";